import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  contracts: [],
  contract: undefined,
  chats: [],
  adminContracts: [],
};

export const contractSlice = createSlice({
  name: 'contract',
  initialState,
  reducers: {
    setContracts: (state, action) => {
      state.contracts = action.payload;
    },
    setContract: (state, action) => {
      state.contract = action.payload;
    },
    setChats: (state, action) => {
      state.chats = action.payload;
    },
    addMessageToChat: (state, action) => {
      const { chatExternalReference, message } = action.payload;

      const chat = state.chats.find((chat) => chat.externalReference === chatExternalReference);

      if (chat) {
        chat.messages.unshift(message);
      }
    },
    setAdminContracts: (state, action) => {
      state.adminContracts = action.payload;
    },
    resetContractSlice: () => initialState,
  },
});

export const { setContracts, setContract, setChats, addMessageToChat, setAdminContracts, resetContractSlice } =
  contractSlice.actions;

export default contractSlice.reducer;
